export const defaultState = {
  type: 'None',
  size: null,
  industries: null,
  country: null,
  name: '',
  address: {
    line1: '',
    line2: '',
    postCode: '',
    city: '',
    country: null,
  },
  invoiceAddressSame: true,
  invoiceAddress: {
    line1: '',
    line2: '',
    postCode: '',
    city: '',
    country: null,
  },
  status: true,
  contactPerson: '',
  contactEmail: '',
  agreementSignedDate: null,
  kamUser: null,
  selectedkamUser: null,
  certificationBody: '',
  tempCertificationBody: '',
  certificationBodyLevelDomains: {},
};

const SET_EDIT_DATA = 'SET_EDIT_DATA';
const UPDATE_FIELD = 'UPDATE_FIELD';

export const setEditDataCreator = (payload) => ({ type: SET_EDIT_DATA, payload });
export const updateFieldCreator = (payload) => ({ type: UPDATE_FIELD, payload });

export default function (state = defaultState, action) {
  if (action.type === SET_EDIT_DATA) {
    return {
      ...state,
      ...action.payload,
      address: { ...action.payload.address, country: action.payload.address?.country.id },
      country: action.payload.country?.id,
      certificationBody: action.payload.certificationBody?.id,
      agreementSignedDate: action.payload.agreementSignedDate
        ? new Date(action.payload.agreementSignedDate)
        : undefined,
      kamUser: action.payload.kamUser?.id,
      selectedkamUser: action.payload.kamUser ? {value: action.payload.kamUser.id, label: `${action.payload.kamUser.firstName} ${action.payload.kamUser.lastName}`} : null
    };
  }
  if (action.type === UPDATE_FIELD) {
    if (action.payload.name === 'certificationBodyLevelDomains') {
      return { ...state, tempCertificationBody: '', [action.payload.name]: action.payload.value };
    }
    return { ...state, [action.payload.name]: action.payload.value };
  }

  return state;
}
